import Link from "next/link";
import { useIntl } from "react-intl";
import { Section } from "@/components/common/section/Section";
import styles from "./AccountError.module.scss";

type AccountErrorProps = {
  lastname?: string;
  firstname?: string;
};

export const AccountError = ({ lastname, firstname }: AccountErrorProps) => {
  const intl = useIntl();

  return (
    <div className={styles.error}>
      <Section containerStyle={styles.errorContent}>
        <div className={styles.errorTitle}>
          {lastname !== undefined &&
            firstname !== undefined &&
            intl.formatMessage(
              { id: "accountGreet" },
              {
                lastname: lastname,
                firstname: firstname,
              }
            )}
        </div>
        <div className={styles.errorBody}>
          {intl.formatMessage({ id: "accountError" })}
          <Link href="/">
            <a className={styles.goBackLink}>
              {intl.formatMessage({ id: "goBackHome" })}
            </a>
          </Link>
        </div>
      </Section>
    </div>
  );
};
